import React, { useRef } from 'react';
import styled from 'styled-components';

import { Button } from '@column/column-ui-kit';

import { PageActions } from '~/app/Layout/PageFrameContext';
import { ContactForm } from '~/components';
import { useSessionStore } from '~/stores/Session';
import { Inner } from '~/styles';

const Container = styled.div`
  max-width: 660px;
  width: 100%;
  margin: 0 auto;
`;

export const PageContact: React.FC = () => {
  const currentUser = useSessionStore((s) => s.currentUser);
  const formRef = useRef<{ submit: () => void }>(null);

  return (
    <>
      <PageActions>
        <Button onClick={() => formRef.current?.submit()} size="small">
          Submit
        </Button>
      </PageActions>
      <Container>
        <Inner>
          <ContactForm
            ref={formRef}
            initialValues={{
              firstName: currentUser?.firstName,
              lastName: currentUser?.lastName,
              email: currentUser?.email,
            }}
          />
        </Inner>
      </Container>
    </>
  );
};
